// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__cOQNQ","link":"Footer_link__DRi5g"};